import { environment } from 'src/environments/environment';

export const AppConfig = {
  name: `Yo Compro en Oviedo`,
  keywords: `Bonos, Yo Compro en Oviedo, Establecimiento, Ayuntamiento, Comercios`,
  description: `Yo Compro en Oviedo. Ayuntamiento de Oviedo.`,
  urlToClientApp: `https://oviedo.client.staging.qaroni.net`,
  version: environment.version,
};
